import React, { useEffect } from "react";
import { useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import MenuItem from "@mui/material/MenuItem";
import dayjs from "dayjs";
import { MedicalAPI } from "../api";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { validateDate } from "@mui/x-date-pickers/internals";
import { useSelector } from "react-redux";
import { selectUser, logoutSuccess } from "../../redux/modules/userSlice";
import { useLocation, useParams } from "react-router-dom";
import useDraft from "../../hooks/useDraft";
import { toast } from "react-toastify";
import DraftSavedAt from "../Shared/DraftSavedAt";
import { pickSectionDraftData } from "../../drafts/draftHelpers";

const hydrateSelfMember = (items, userData) => {
  if (!Array.isArray(items) || !items.length || !userData) return items;

  const nextItems = [...items];
  const firstItem = { ...nextItems[0] };
  const sectionAName = userData.name || "";
  const sectionADob = userData.dateOfBirth || "";

  if (sectionAName) firstItem.name = sectionAName;
  if (!firstItem.relationship) firstItem.relationship = "Self";
  if (!firstItem.dob && sectionADob) firstItem.dob = sectionADob;

  nextItems[0] = firstItem;

  return nextItems;
};

function SectionE({ changeTab, handleButtonClick }) {
  const { user } = useSelector(selectUser);
  const inititalState = [
    {
      userId: user.isAdmin ? id : user._id,
      name: "",
      relationship: "Self",
      dob: "",
    },
  ];

  const [medicalInsurance, setMedicalInsurance] = useState([...inititalState]);

  const params = useParams();
  const id = params.id ? params.id : "";
  const { loadDraft, saveDraft, deleteDraft, saving: draftSaving, lastDraftedAt } = useDraft(
    "newJoinee",
    "E",
  );
  const [newJoineeSectionEFlagButton, setNewJoineeSectionEFlagButton] =
    useState("");
  const [error, setError] = useState(
    Array.from(medicalInsurance, (e, i) => {
      return { name: "" };
    })
  );
  const regexName = /^[a-zA-Z\s]+$/;

  useEffect(() => {
    let isActive = true;

    (async () => {
      let draftApplied = false;

      if (!user.isAdmin) {
        const loadedDraft = await loadDraft();
        const draftData = loadedDraft && loadedDraft.data ? loadedDraft.data : null;
        const items =
          draftData &&
          draftData.medicalInsurance &&
          Array.isArray(draftData.medicalInsurance.medicalInsurance)
            ? draftData.medicalInsurance.medicalInsurance
            : null;
        if (isActive && items && items.length > 0) {
          setMedicalInsurance([...items]);
          draftApplied = true;
        }
      }

      MedicalAPI.getMedicalInsurance(user.isAdmin ? id : user._id)
        .then((res) => {
          if (!isActive) return;
          if (!draftApplied) {
            if (res.data.length > 0) {
              setMedicalInsurance(hydrateSelfMember([...res.data], res.userData));
            } else {
              const fallback = [
                {
                  userId: user.isAdmin ? id : user._id,
                  name: res.userData.name,
                  relationship: "Self",
                  dob: res.userData.dateOfBirth,
                },
              ];
              setMedicalInsurance(fallback);
            }
          } else if (res.userData) {
            setMedicalInsurance((current) =>
              hydrateSelfMember(current, res.userData),
            );
          }
          setNewJoineeSectionEFlagButton(
            res ? res.userData.isNewJoineeFormComplete : ""
          );
        })
        .catch((err) => {
          console.log(err);
        });
    })();

    return () => {
      isActive = false;
    };
  }, [id, loadDraft, user._id, user.isAdmin]);

  const handleSaveDraft = async () => {
    if (user.isAdmin) return;
    if (!medicalInsurance[0] || !medicalInsurance[0].dob) {
      toast.error("Please complete Section A date of birth before saving Section E draft");
      return;
    }
    const wrapped = pickSectionDraftData("newJoinee", "E", { medicalInsurance });
    const saved = await saveDraft(wrapped);
    if (saved && saved.skipped) {
      toast.info("Nothing to save as draft");
      return;
    }
    if (saved) toast.success("Draft saved");
    else toast.error("Unable to save draft");
  };

  const [validateerror, setvalidateerror] = useState();
  const [ackChecked, setAckChecked] = useState(false);
  const [ackError, setAckError] = useState(false);
  const validatehandler = () => {
    const arr = [
      medicalInsurance.map((e) => e.name),
      medicalInsurance.map((e) => e.relationship),
      medicalInsurance.map((e) => e.dob),
    ];
    var arrName = [
      Array.from(medicalInsurance, (e, i) => `name${i}`),
      Array.from(medicalInsurance, (e, i) => `relationship${i}`),
      Array.from(medicalInsurance, (e, i) => `dob${i}`),
    ];
    const keyObj = [];
    for (let i = 0; i < arr.length; i++) {
      let medicalInsurance = [];
      for (let j in arr[i]) {
        if (!arr[i][j]) {
          medicalInsurance.push({
            name: arrName[i][j],
            status: true,
          });
        } else {
          medicalInsurance.push({
            name: arrName[i][j],
            status: false,
          });
        }
      }
      keyObj.push(medicalInsurance);
    }
    setvalidateerror(keyObj);
    const arrData = [];
    for (let i in arr) {
      for (let j in arr[i]) {
        arrData.push(arr[i][j]);
      }
    }
    const check = arrData.every((e) => {
      if (typeof e === "object") {
        return e.every((x) => x);
      } else {
        return e;
      }
    });
    return check;
  };

  const getPolicyYear = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();

  return month < 6
    ? `July ${year - 1} - June ${year}`
    : `July ${year} - June ${year + 1}`;
};

  const convertToCamelCase = (input) => {
    if (input === null || input.length === 0) {
      return input;
    }
    const words = input.split(" ");
    const camelCaseWords = words.map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });

    return camelCaseWords.join(" ");
  };

  const addMember = () => {
    let tempHistory = [...medicalInsurance];
    tempHistory.push({
      userId: user.isAdmin ? id : user._id,
      name: "",
      relationship: "",
      dob: null,
    });
    setMedicalInsurance([...tempHistory]);
    setError([...error, { name: "" }]);
  };

  const deleteMember = (index) => {
    let tempHistory = [...medicalInsurance];

    if (tempHistory[index]._id) {
      MedicalAPI.deleteMedicalInsurance(tempHistory[index]._id).catch((err) => {
        console.log(err);
      });
    }
    tempHistory.splice(index, 1);
    setMedicalInsurance([...tempHistory]);

    const nameError = [...error];
    nameError.splice(index, 1);
    setError(nameError);
  };

  const handleChange1 = (e, index, field) => {
    const { value } = e.target;
    const camelCaseValue = convertToCamelCase(value);

    if (field === "name" && regexName.test(camelCaseValue)) {
      let tempHistory = [...medicalInsurance];
      tempHistory[index][field] = camelCaseValue;
      setMedicalInsurance([...tempHistory]);
    }
    if (field === "name" && camelCaseValue === "") {
      let tempHistory = [...medicalInsurance];
      tempHistory[index][field] = camelCaseValue;
      setMedicalInsurance([...tempHistory]);
    }

    let errorDestr = [...error];
    if (field === "name") {
      if (!value.trim()) {
        errorDestr[index] = { [field]: errorDestr[index] && true };
      } else {
        errorDestr[index] = { [field]: errorDestr[index] && false };
      }
      setError(errorDestr);
    }

    if (validateerror) {
      const validateName = [...validateerror];
      if (validateName[0][index]) {
        validateName[0][index].status = false;
      }
      setvalidateerror(validateName);
    }
  };

  const handleChange2 = (e, index, field) => {
    const { value } = e.target;
    let tempHistory = [...medicalInsurance];
    tempHistory[index][field] = value;
    setMedicalInsurance([...tempHistory]);

    if (validateerror) {
      const validateRelationship = [...validateerror];
      if (validateRelationship[1][index]) {
        validateRelationship[1][index].status = false;
      }
      setvalidateerror(validateRelationship);
    }
  };

  const handleDateChange = (e, index) => {
    let tempHistory = [...medicalInsurance];

    let date = "";
    if (e) {
      let m = e.$d.getMonth() + 1;
      m = m < 10 ? `0${m}` : m;
      let d = ("0" + e.$D).slice(-2);
      date = e.$d.getFullYear() + "-" + m + "-" + d;

      tempHistory[index].dob = date;
      setMedicalInsurance([...tempHistory]);
    }
    if (validateerror) {
      const validateDate = [...validateerror];
      if (validateDate[2][index]) {
        validateDate[2][index].status = false;
      }
      setvalidateerror(validateDate);
    }
  };

  const handleSubmit = () => {
    if (!ackChecked) {
      setAckError(true);
      toast.error("Please acknowledge the details added by you are true", {
        hideProgressBar: true,
        closeOnClick: true,
      });
      return;
    }
    if (validatehandler()) {
      handleButtonClick("sectionE");
      medicalInsurance.map((history) => {
        if (history._id) {
          MedicalAPI.updateMedicalInsurance(
            user.isAdmin ? id : history._id,
            history
          );
          return;
        } else {
          MedicalAPI.createMedicalInsurance(history);
          return;
        }
      });
      // After official save, clear only Section E draft (if any).
      if (!user.isAdmin) deleteDraft();
      changeTab(4);
    }
  };

  const handlechangeAll = () => {
    const clearField = [
      {
        name: medicalInsurance[0].name,
        relationship: "Self",
        dob: dayjs(medicalInsurance.dob),
      },
    ];
    setMedicalInsurance([...clearField]);
  };

  return (
    <div>
      <div className={`col-12 ${user.isAdmin ? "" : "my-5"}`}>
        <div>
          <h4>
            <span style={{ fontWeight: "600" }} className="fs-4">
              Medical Insurance Details
            </span>
          </h4>
        </div>
        <div className="col-12 py-3">
          <div className="col-10 text-dark">
            <h6>
              <span style={{ fontWeight: "500" }}>Note :</span>
            </h6>
            <ul>
              <li>General Policy coverage: Member + Spouse + 2 kids</li>
              <li>
                Addition of parents to GMC: Member has to be bear a nominal
                Insurance premium of Rs. 6000/- (Per head) for the current
                year (Jun'27-Jun'26 in every year) to get added under GMC, the same
                would be deducted in 2 instalments
              </li>
              <li>
                Policy Sum Assured: Graded sum insured Rs. 3,00,000/-
                (Unmarried) & Rs. 4,00,000/-(Family)
              </li>
            </ul>
          </div>
        </div>
        <section>
          <div className="">
            <Box sx={{ width: "100%" }}>
              {medicalInsurance.map((med, index) => {
                return (
                  <Grid container spacing={3} sx={{ marginBottom: "2%" }}>
                    <Grid item>
                      <TextField
                        sx={{ width: "35ch" }}
                        label="Full Name"
                        value={med.name}
                        error={
                          validateerror && validateerror[0][index]
                            ? validateerror[0][index].status
                            : ""
                        }
                        onChange={(e) => handleChange1(e, index, "name")}
                        helperText={
                          error.length > 0 && error[index] && error[index].name
                            ? "Invalid Name"
                            : ""
                        }
                        required
                        disabled={
                          index === 0 ||
                          (user.isAdmin &&
                            (newJoineeSectionEFlagButton === "pending" ||
                              newJoineeSectionEFlagButton === "submitted" ||
                              newJoineeSectionEFlagButton === "review done" ||
                              newJoineeSectionEFlagButton ===
                                "resubmission required"))
                        }
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        select
                        sx={{ width: "35ch" }}
                        label="Relationship"
                        value={med.relationship}
                        error={
                          validateerror && validateerror[1][index]
                            ? validateerror[1][index].status
                            : ""
                        }
                        onChange={(e) =>
                          handleChange2(e, index, "relationship")
                        }
                        required
                        disabled={
                          index === 0 ||
                          (user.isAdmin &&
                            (newJoineeSectionEFlagButton === "pending" ||
                              newJoineeSectionEFlagButton === "submitted" ||
                              newJoineeSectionEFlagButton === "review done" ||
                              newJoineeSectionEFlagButton ===
                                "resubmission required"))
                        }
                      >
                        <MenuItem value="Self" disabled>
                          Self
                        </MenuItem>
                        <MenuItem value="Spouse">Spouse</MenuItem>
                        <MenuItem value="Daughter">Daughter</MenuItem>
                        <MenuItem value="Son">Son</MenuItem>
                        <MenuItem value="Mother">Mother</MenuItem>
                        <MenuItem value="Father">Father</MenuItem>
                        <MenuItem value="Mother-in-law">Mother-in-law</MenuItem>
                        <MenuItem value="Father-in-law">Father-in-law</MenuItem>
                      </TextField>
                    </Grid>
                    <Grid
                      item
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          sx={{ width: "22ch" }}
                          format="DD/MM/YYYY"
                          error={
                            validateerror && validateerror[2][index]
                              ? validateerror[2][index].status
                              : ""
                          }
                          label="Date of Birth"
                          value={med.dob ? dayjs(med.dob) : null}
                          onChange={(date) => handleDateChange(date, index)}
                          renderInput={(params) => <TextField {...params} />}
                          required
                          disabled={
                            index === 0 ||
                            (user.isAdmin &&
                              (newJoineeSectionEFlagButton === "pending" ||
                                newJoineeSectionEFlagButton === "submitted" ||
                                newJoineeSectionEFlagButton === "review done" ||
                                newJoineeSectionEFlagButton ===
                                  "resubmission required"))
                          }
                        />
                      </LocalizationProvider>
                      <FormLabel
                        style={{
                          display:
                            validateerror &&
                            validateerror[2][index] &&
                            validateerror[2][index].status
                              ? ""
                              : "none",
                        }}
                        sx={{ color: "red" }}
                      >
                        (please select date)
                      </FormLabel>
                    </Grid>
                    {index > 0 ? (
                      <DeleteForeverIcon
                        onClick={() => deleteMember(index)}
                        sx={{
                          color: "red",
                          cursor: "pointer",
                          marginLeft: "5px",
                          marginTop: "40px",
                        }}
                      />
                    ) : (
                      <> </>
                    )}
                  </Grid>
                );
              })}
              <div className="col-10 ms-2 border-bottom border-2"></div>
            </Box>
          </div>
        </section>
        <div className="col-10 ms-2 mb-3 border-bottom border-2"></div>
        <div className="col-12 mb-5">
          <button
            onClick={() => addMember()}
            type="button"
            className="btn btn-outline-primary"
            disabled={
              user.isAdmin &&
              (newJoineeSectionEFlagButton === "pending" ||
                newJoineeSectionEFlagButton === "submitted" ||
                newJoineeSectionEFlagButton === "review done" ||
                newJoineeSectionEFlagButton === "resubmission required")
            }
          >
            <span style={{ fontSize: "" }}>+ Add Family Member</span>
          </button>
        </div>
        {user.isAdmin ? (
          ""
        ) : (
          <div className="col-12 mb-4 px-3">
            <FormControlLabel
              control={
                <Checkbox
                  checked={ackChecked}
                  onChange={(e) => {
                    setAckChecked(e.target.checked);
                    if (e.target.checked) setAckError(false);
                  }}
                />
              }
              label="I acknowledge the details added by me are true"
            />
            {ackError && (
              <div style={{ color: "red", marginTop: "4px" }}>
                Please acknowledge the details added by you are true.
              </div>
            )}
          </div>
        )}
        {newJoineeSectionEFlagButton === "review done" ||
        ((newJoineeSectionEFlagButton === "pending" ||
          newJoineeSectionEFlagButton === "submitted" ||
          newJoineeSectionEFlagButton === "resubmission required") &&
          user.isAdmin) ? (
          ""
        ) : (
          <div className="d-flex align-items-center">
            <div className="d-flex align-items-center">
              {!user.isAdmin && (
                <button
                  onClick={() => handleSaveDraft()}
                  type="button"
                  className="btn btn-outline-primary btn-lg px-5 me-4"
                  disabled={draftSaving}
                >
                  Save Draft
                </button>
              )}
              <button
                onClick={() => handleSubmit()}
                type="button"
                className="btn btn-primary btn-lg px-5 me-4"
              >
                Save
              </button>
              <button
                type="button"
                onClick={() => handlechangeAll()}
                className="btn btn-outline-primary btn-lg px-5"
              >
                Clear All
              </button>
            </div>

            {!user.isAdmin ? (
              <DraftSavedAt className="ms-auto" date={lastDraftedAt} />
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
}

export default SectionE;
